$bog_pazzle_layout $mol_view
	Menu $bog_pazzle_menu
	Upload $bog_pazzle_upload
	sub /
		<= Menu
		<= Upload
